import React from 'react';
import * as styles from './ProvisionSSODefaultBadge.module.scss';
import Badge from '../../components/Badge';
import Tooltip from '../../components/Tooltip';

const ProvisionSSODefaultBadge = () => (
  <div className={styles.badge}>
    <Tooltip
      trigger="clickOrHover"
      content={`This provision is assigned\nto new users who sign up via SSO,\nunless they are manually assigned\na provision when invited`}
    >
      <Badge color="gray">SSO Default</Badge>
    </Tooltip>
  </div>
);

export default ProvisionSSODefaultBadge;
